"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1CombinedGet = void 0;
exports.v1CombinedGetSetMock = v1CombinedGetSetMock;
exports.v1CombinedGet = v1CombinedGet;
exports.useQueryV1CombinedGet = useQueryV1CombinedGet;
exports.useInfiniteQueryV1CombinedGet = useInfiniteQueryV1CombinedGet;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1CombinedGetSetMock(mock) {
    setMock = mock;
}
async function v1CombinedGet(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/combined/${params.softwareNumber}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.equipmentType = params.equipmentType;
    queryParams.platform = params.platform;
    queryParams.date = params.date;
    queryParams.userType = params.userType;
    queryParams.isClub = params.isClub;
    queryParams.isEmbedded = params.isEmbedded;
    queryParams.doEnableScaling = params.doEnableScaling;
    queryParams.useMetricUnits = params.useMetricUnits;
    queryParams.period = params.period;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1CombinedGet = 'wolf-dashboard-service:v1CombinedGet:get';
function useQueryV1CombinedGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1CombinedGet, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1CombinedGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1CombinedGet, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1CombinedGet(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-combined-get.js.map